import { useQuery } from '@tanstack/react-query';
import { fetchVariableCatalog } from '@/document-types/application/fetchVariableCatalog';
import type { DocumentTypeRef, DocumentTypeVariableCategory } from '@/document-types/domain/types/DocumentType';

export const variableCatalogQueryKey = (ref: DocumentTypeRef | undefined) =>
  ['document-builder', 'document-type-variables', ref?.applicationKey, ref?.moduleKey, ref?.documentTypeKey] as const;

export const useVariableCatalog = (ref?: DocumentTypeRef) => {
  const enabled = !!ref?.applicationKey && !!ref?.moduleKey && !!ref?.documentTypeKey;

  return useQuery({
    queryKey: variableCatalogQueryKey(ref),
    enabled,
    queryFn: async (): Promise<DocumentTypeVariableCategory[]> => {
      if (!ref) throw new Error('DocumentTypeRef is required');
      return fetchVariableCatalog(ref);
    },
    staleTime: 1000 * 60 * 10
  });
};
